module.exports = ""


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Login/login.component.html
// module id = ../../../../../src/app/Login/login.component.html
// module chunks = 0